import CustomerState from "infrastructure/store/customer/CustomerState";
import IAppState from "infrastructure/store/IAppState";
import React from "react";
import { useSelector } from "react-redux";
import CustomerCard from "../components/CustomerCard";
import DashboardSectionProps from "features/dashboard/models/DashboardSectionProps";
import ContractsCountState from "infrastructure/store/contractsCount/ContractsCountState";

const DashboardCustomerSection = (props: DashboardSectionProps) => {
  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;
  const contractsCount = useSelector<IAppState, ContractsCountState>((store) => store.contractsCount).contractsCount;

  // render
  return (
    <CustomerCard
      customer={customer}
      contractCounts={contractsCount}
      headerBg={props.background}
    />
  );
};

export default DashboardCustomerSection;
